module.exports = __webpack_public_path__ + "static/media/investor-v2-vector.61e55c16.png";